"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPCentralOrganization = void 0;
const firebase_1 = require("../bindings/firebase");
class SPCentralOrganization {
    constructor(inputOrganization) {
        this.address = inputOrganization.address;
        this.visit_address = inputOrganization.visit_address;
        this.practice_day = inputOrganization.practice_day;
        this.altered = inputOrganization.altered;
        this.created_by = inputOrganization.created_by;
        this.bank_account = inputOrganization.bank_account;
        this.comment = inputOrganization.comment;
        this.contact = inputOrganization.contact;
        this.created = inputOrganization.created;
        this.members = inputOrganization.members;
        this.org_id = inputOrganization.org_id;
        this.org_name = inputOrganization.org_name;
        this.org_number = inputOrganization.org_number;
        this.region_id = inputOrganization.region_id;
        this.pictures = inputOrganization.pictures;
        this.web_page = inputOrganization.web_page;
        this.founding_date = inputOrganization.founding_date;
        this.custom_fields = inputOrganization.custom_fields;
        this.kontigent = inputOrganization.kontigent;
        this.board_id = inputOrganization.board_id;
        this.has_portal = inputOrganization.has_portal;
        this.status = inputOrganization.status;
        this.sentral_ref = inputOrganization.sentral_ref;
        this.portal_ref = inputOrganization.portal_ref;
    }
    static new(data) {
        let orgData = {
            address: {
                address: '',
                city: '',
                post_code: '',
            },
            visit_address: {
                address: '',
                city: '',
                post_code: '',
                place: '',
            },
            practice_day: {
                day: undefined,
                start_time: undefined,
                end_time: undefined,
            },
            altered: firebase_1.firebase.firestore.Timestamp.now(),
            bank_account: '',
            contact: { invoice_email: '' },
            created: firebase_1.firebase.firestore.Timestamp.now(),
            members: 0,
            org_id: '',
            org_name: '',
            org_number: '',
            board_id: -1,
            has_portal: false,
            status: 'A',
        };
        Object.keys(data).forEach((key) => {
            // already have checks that key is in both
            orgData[key] = data[key];
        });
        return new this(orgData);
    }
    static fromQueryDocumentSnapshot(snapshot) {
        if (!snapshot.exists) {
            throw new Error('CentralOrg snapshot does not exist');
        }
        const org = this.new(snapshot.data());
        org._querySnap = snapshot;
        org._ref = snapshot.ref;
        org._parentId = snapshot.id;
        return org;
    }
    static fromQuerySnapshot(snapshot) {
        const orgs = [];
        if (snapshot.empty) {
            return orgs;
        }
        for (const d of snapshot.docs) {
            const org = this.fromQueryDocumentSnapshot(d);
            if (org) {
                orgs.push(org);
            }
        }
        return orgs;
    }
    static async fromFirebase(orgid) {
        const snapshot = await (0, firebase_1.fs)()
            .collection('organizations')
            .doc(orgid)
            .get();
        return this.fromQueryDocumentSnapshot(snapshot);
    }
    getRaw() {
        const rawData = { ...this };
        Object.keys(rawData).forEach((key) => {
            if (key.startsWith('_')) {
                delete rawData[key];
            }
        });
        return rawData;
    }
    parentID() {
        if (!this._parentId) {
            throw new Error(`Somehow parentid does not exist! ${this.org_name}`);
        }
        return this._parentId;
    }
    querySnap() {
        if (!this._querySnap) {
            throw new Error(`Somehow querysnap does not exist! ${this.org_name}`);
        }
        return this._querySnap;
    }
    ref() {
        if (!this._ref) {
            throw new Error(`Somehow ref does not exist! ${this.org_name}`);
        }
        return this._ref;
    }
    getId() {
        const qs = this.querySnap();
        if (!qs) {
            throw new Error(`Somehow id does not exist! ${this.org_name}`);
        }
        return qs.id;
    }
}
exports.SPCentralOrganization = SPCentralOrganization;
//# sourceMappingURL=centralOrganization.js.map